import { AjaxService } from "../Helpers/AjaxService";
import { OsrTrade } from "../Models/Osr/OsrTrade";
import { OsrSamplesGroupByCropNumber } from "../Models/Osr/OsrSamplesGroupByCropNumber";
import { OsrDeliveryGroupedByCropNumber } from "../Models/Osr/OsrDeliveryGroupedByCropNumber";

export class OsrApi {
    private static instance: OsrApi;
    static getInstance() { return OsrApi.instance || (OsrApi.instance = new OsrApi()); }

    getTrades(): Promise<OsrTrade[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/osr/gettrades`;
        return new Promise<OsrTrade[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: OsrTrade[]) => {
                    resolve(result);
                });
        });
    }

    getDeliveries(): Promise<OsrDeliveryGroupedByCropNumber[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/osr/getdeliveries`;
        return new Promise<OsrDeliveryGroupedByCropNumber[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: OsrDeliveryGroupedByCropNumber[]) => {
                    resolve(result);
                });
        });
    }

    getSamples(): Promise<OsrSamplesGroupByCropNumber[]> {
        const ajaxService = AjaxService.getInstance();
        const apiUrl = `/api/osr/getsamples`;
        return new Promise<OsrSamplesGroupByCropNumber[]>((resolve) => {
            ajaxService.getWithContentType(apiUrl,
                "application/json",
                (result: OsrSamplesGroupByCropNumber[]) => {
                    resolve(result);
                });
        });
    }
}